import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-start d-flex mt-4 justify-content-between print-section" }
const _hoisted_3 = { class: "card-left col-12" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.arData.logo || '@/assets/images/Logo.svg',
          alt: "Logo da Autoridade de Registro",
          class: "doc-print-logo"
        }, null, 8, _hoisted_4),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center fw-600" }, "DOCUMENTO RESERVADO", -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "divisor" }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", null, "Dados para emitir Certificado Digital após aprovação", -1)),
        _createElementVNode("div", null, [
          _cache[0] || (_cache[0] = _createElementVNode("strong", null, "Código da solicitação: ", -1)),
          _createTextVNode(_toDisplayString(_ctx.form.codigoSolicitacao), 1)
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "divisor" }, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("div", null, " Após aprovação da sua Solicitação, utilize os dados informados abaixo para fazer a instalação do Certificado Digital. ", -1)),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "fw-600" }, "Usuário: ", -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.form.user), 1)
        ]),
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"info-box\" data-v-4d7ad70f><span class=\"fw-600\" data-v-4d7ad70f>Senha: </span> criada pelo usuário </div><div class=\"divisor\" data-v-4d7ad70f></div><div class=\"fw-600\" data-v-4d7ad70f>Atenção</div><div data-v-4d7ad70f><span class=\"fw-600\" data-v-4d7ad70f>Para sua segurança</span>, guarde este documento em local seguro até que emita seu Certificado Digital Soluti. </div><div data-v-4d7ad70f> Após a emissão, esses dados não serão mais necessários e este documento poderá ser descartado. </div>", 5))
      ])
    ])
  ]))
}